<template>
  <div class="" >
    <b-modal ref="my-modal" size="sm" hide-footer title="">
      <div class="d-block text-center">
        <h3>場次</h3>
      </div>

      <div class="form-group row">
        <div class="col-sm-12">
          <table class="table table-hover" id="tblMain">
            <thead class="thead-light">
            <tr>
              <th>選取</th>
              <th>場次名稱</th>
              <th>類型</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in this.formData.EventItems" :key="index">
              <td>
                <input type="checkbox" :value="item.SystemId" v-model="SelectEventItems" >
              </td>
              <td width="200px">
                {{item.Name}}
              </td>
              <td width="200px">
                <div v-if="item.Type===CheckIn_EventItemType_Open">
                  開放型 (不需預先報名)
                </div>
                <div v-else-if="item.Type===CheckIn_EventItemType_NeedReg">
                  需先報名
                </div>
                <div v-else>
                  XX:{{item.MediaType}}
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-if="Mode==='1'">
        <b-button class="mt-2" variant="btn btn-primary" block @click="toggleModalAdd()">加入場次</b-button>
        <b-button class="mt-2" variant="btn btn-primary" block @click="toggleModalRemove()">移除場次</b-button>

      </div>

      <div v-if="Mode==='2'">
        <b-button class="mt-2" variant="btn btn-primary" block @click="toggleModalSelect()">選取</b-button>

      </div>
      <b-button class="mt-3" variant="btn btn-danger" block @click="hideModal">關閉</b-button>
    </b-modal>
  </div>

</template>



<script>
/**
<DLGEventItems ref="dlgEventItems" v-on:returnAdd="dlgEventItemsReturnAdd" v-on:returnRemove="dlgEventItemsReturnRemove"  v-on:returnSelect="dlgEventItemsReturnSelect" mode='1' />


editHtmlContent(item){
  this.$refs.dlgEventItems.EventSystemId="";
  this.$refs.dlgEventItems.showModal();
},
dlgEventItemsReturnAdd(items){
  item.HelpContent.Content=this.$refs.dlgEventItems.htmlContent;
},
dlgEventItemsReturnRemove(items){
  item.HelpContent.Content=this.$refs.dlgEventItems.htmlContent;
},
 dlgEventItemsReturnSelect(items){
  item.HelpContent.Content=this.$refs.dlgEventItems.htmlContent;
}


 **/
import util from "@/util/util";
import apiAdmin from "@/views/taylorAdmin/js/apiAdmin";
import {CheckIn_EventItemType_Open,CheckIn_EventItemType_NeedReg} from "@/views/checkInAdmin/js/checkInDeclare";
import apiCheckIn from "@/views/checkInAdmin/js/apiCheckIn";

export default {
  props: ['EventSystemId','Mode'], //tag  postTitle="hi"  data this.postTitle
  data: function () {
    return {
      CheckIn_EventItemType_Open:CheckIn_EventItemType_Open,
      CheckIn_EventItemType_NeedReg:CheckIn_EventItemType_NeedReg,
      // type: "",
      formData: {
        Name: "",
        Memo:"",
        EventItems:[],
      },
      SelectEventItems:[],
    };
  },
  methods: {
    showModal() {
      this.getItem();
      this.$refs['my-modal'].show()
    },
    hideModal() {
      this.$refs['my-modal'].hide()
    },
    toggleModalAdd() {
      this.$refs['my-modal'].toggle('#toggle-btn')

      this.$emit('returnAdd',this.SelectEventItems);
    },
    toggleModalRemove() {
      this.$refs['my-modal'].toggle('#toggle-btn')

      this.$emit('returnRemove',this.SelectEventItems);
    },

    toggleModalSelect() {
      this.$refs['my-modal'].toggle('#toggle-btn')

      this.$emit('returnSelect',this.SelectEventItems);
    },

    getItem:function(){
      let that=this

      let loader=util.ShowLoading(this);
      if (this.EventSystemId){
        apiCheckIn.api_Event_Get(this.EventSystemId).then((data)=>{
          that.formData=apiAdmin.initReturnObjectWithTemplate(data.data.data,this.formData);
          util.HideLoading(loader);
        });
      }else{
        util.HideLoading(loader);
      }
    },
  },
  mounted() {

  },
}
</script>

<style scoped>

</style>
